import { ICalType } from 'models/ICal';

export const providerToLabelMap = {
  [ICalType.AIRBNB]: 'Airbnb',
  [ICalType.BOOKING_COM]: 'Booking.com',
  [ICalType.VRBO]: 'Vrbo',
  [ICalType.TRIP_ADVISOR]: 'TripAdvisor',
};
